import { isIpfError } from '@ipfabric/frontend-shared-assets/utils/IpfError';
import {
  API_EMPTY_CREDENTIALS,
  API_NOTHING_TO_DO,
} from '@ipfabric/utils/apiErrorCodes';
import type { ShowNotificationCommand } from 'utils/hooks/useNotifications';

interface Args {
  error: unknown;
  showNotification: (command: ShowNotificationCommand) => void;
}

// Event handler has been reduced from original error handling in saga as sagas has lots of historical baggage.
// https://gitlab.com/ip-fabric/development/product/ipfabric-product/-/merge_requests/9090#note_2768352151
export const handleDiscoveryError = ({ error: e, showNotification }: Args) => {
  if (
    isIpfError(e, 'API') &&
    e.payload?.response.code === API_EMPTY_CREDENTIALS
  ) {
    showNotification({
      type: 'danger',
      message:
        'Please set Device credentials or Vendor API(s) in discovery settings first',
    });
    return;
  }
  if (isIpfError(e, 'API') && e.payload?.response.code === API_NOTHING_TO_DO) {
    showNotification({
      type: 'danger',
      message: 'No timed out IP addresses exist',
    });
    return;
  }
  throw e;
};
